import { Cpu, Wrench, Shield, Box } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export const TYPE_ICONS: Record<string, LucideIcon> = {
  llm: Cpu,
  tool: Wrench,
  guardrail: Shield,
  general: Box,
};

export const TYPE_COLORS: Record<string, string> = {
  llm: 'text-purple-600 bg-purple-50',
  tool: 'text-orange-600 bg-orange-50',
  guardrail: 'text-green-600 bg-green-50',
  general: 'text-gray-600 bg-gray-50',
};

/** Bar fill colors for timeline Gantt chart */
export const TYPE_BAR_COLORS: Record<string, string> = {
  llm: 'bg-purple-400',
  tool: 'bg-orange-400',
  guardrail: 'bg-green-400',
  general: 'bg-gray-400',
};

/** Format duration in ms to human-readable string */
export function formatDuration(ms: number | null | undefined): string {
  if (ms == null) return '—';
  if (ms >= 1000) return `${(ms / 1000).toFixed(1)}s`;
  return `${Math.round(ms)}ms`;
}

/** Format token count to compact string (e.g., 1234 → "1.2k") */
export function formatTokens(count: number | null | undefined): string {
  if (count == null) return '—';
  if (count >= 10000) return `${(count / 1000).toFixed(0)}k`;
  if (count >= 1000) return `${(count / 1000).toFixed(1)}k`;
  return String(count);
}
